// Large, faded, partially-cropped palm-frond silhouette used as a background illustration behind
// the Atpūtas ceļojumi section (see CharterDealsCarousel.module.css for placement/opacity/crop —
// this component only draws the shape). Not an icon: no color, no detail, meant to read as a
// soft tropical atmosphere in the corner of the section, never compete with cards or text.
const BLADES = [
  { length: 230, rotate: -13 },
  { length: 265, rotate: 10 },
  { length: 285, rotate: 33 },
  { length: 275, rotate: 57 },
  { length: 250, rotate: 79 },
  { length: 210, rotate: 101 },
];

function Blade({ length, rotate }) {
  const half = 14 + length * 0.032;
  return (
    <path
      transform={`rotate(${rotate})`}
      d={`M0,0 Q${length * 0.45},${-half} ${length},0 Q${length * 0.45},${half} 0,0 Z`}
    />
  );
}

export function PalmDecoration({ className }) {
  return (
    <svg className={className} viewBox="-20 -20 360 360" aria-hidden="true" focusable="false">
      <g fill="#c9a15a">
        {BLADES.map((b) => (
          <Blade key={b.rotate} {...b} />
        ))}
      </g>
      <path
        d="M0,0 C40,35 65,80 78,140"
        stroke="#b8874a"
        strokeWidth="10"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
